// This component scrolls to the top of the page whenever the route changes.

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation(); // Gets the current route path

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when path changes
  }, [pathname]);  // Triggers effect whenever the path changes

  return null;  // This component doesn't render anything
};

export default ScrollToTop;
